<template>
  <div class="channel">
    <div class="discern">
      <div class="big-title">
        <p>渠道风控</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>人脸识别系统</h2>
        </div>
      </div>
      <div class="second-title">
        <div class="frist-line">价值意义</div>
        <p>
          人脸识别判客规则和百度人脸识别技术有效结合，实现智能判断客户到访时间与渠道推荐时间的先后，得出是否飞单、洗客、截客结论。大大降低内单外飞风险和营销费用，以及后期人工核查成本！
        </p>
      </div>
      <div class="meaning">
        <div class="item">
          <img src="../../static/images/product/mean_one.png" />
          <div class="right">
            <div class="item-title">智能化数据采集</div>
            <div class="item-desc">
              以线下人脸数据为基础，对客流统计、属性统计、轨迹统计进行采集
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/mean_two.png" />
          <div class="right">
            <div class="item-title">多维数据整合</div>
            <div class="item-desc">以购房客户为核心，打通融合各类系统数据</div>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/mean_three.png" />
          <div class="right">
            <div class="item-title">AI智能分析</div>
            <div class="item-desc">用户画像（客户标签化、画像模型）</div>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/mean_four.png" />
          <div class="right">
            <div class="item-title">全面提高案场核心价值</div>
            <div class="item-desc">
              推进由业务处理型向营销服务型转变，提升营销，营销氛围营造
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/mean_five.png" />
          <div class="right">
            <div class="item-title">新型人脸识别技术</div>
            <div class="item-desc">增强用户体验度：人脸识别、无感判断</div>
          </div>
        </div>
      </div>
      <div class="phone-title">样机显示效果</div>
    </div>

    <div class="effect">
      <div class="phone-box">
        <div class="row-tab">
          <div class="swiper-container myRow" ref="slider">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                :class="{ active: selectId == item.id }"
                v-for="(item, index) in featureList"
                :key="item.id"
                @click="changeRowTabs(item.id, index)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>

        <div class="column-tab">
          <div class="swiper-container myColumn" ref="columnSwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in featureList"
                :key="item.id"
              >
                <img :src="item.img" />
                <span>{{ item.title }}</span>
                <div class="desc">
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="discern">
      <div class="second-title">
        <div class="frist-line">案场摄像头标准部署图</div>
        <p>
          在大堂入口处、沙盘、区位图、景观连廊、样板间等处，摄像头自动无感抓拍客户人脸头像，储存至来访客户索引库。
        </p>
      </div>
      <div class="deploy">
        <div class="tab-nav">
          <div
            class="item"
            @click="changeTabs(0)"
            :class="{ active: tabId == 0 }"
          >
            1.样板间
          </div>
          <div
            class="item"
            @click="changeTabs(1)"
            :class="{ active: tabId == 1 }"
          >
            2.洽谈区
          </div>
          <div
            class="item"
            @click="changeTabs(2)"
            :class="{ active: tabId == 2 }"
          >
            3.景观连廊
          </div>
          <div
            class="item"
            @click="changeTabs(3)"
            :class="{ active: tabId == 3 }"
          >
            4.样板间
          </div>
          <div
            class="item"
            @click="changeTabs(4)"
            :class="{ active: tabId == 4 }"
          >
            5.营销中心大门
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div>
        <div class="show-img">
          <div class="houese left-top" v-show="tabId == 0">
            <img src="../../static/images/product/view.png" />
            <p>样板间</p>
          </div>
          <div class="houese left-bottom" v-show="tabId == 4">
            <img src="../../static/images/product/view.png" />
            <p>营销中心大门</p>
          </div>
          <div class="houese right-top-img" v-show="tabId == 2">
            <img src="../../static/images/product/view.png" />
            <p>景观连廊</p>
          </div>
          <div class="houese right-middle" v-show="tabId == 1">
            <img src="../../static/images/product/view.png" />
            <p>洽谈区</p>
          </div>
          <div class="houese right-bottom" v-show="tabId == 3">
            <img src="../../static/images/product/view.png" />
            <p>样板间</p>
          </div>
          <div class="pad-content">
            <img src="../../static/images/product/pad_content.png" />
            <div class="screen-left one" @click="changeTabs(0)">
              <span>1</span>
            </div>
            <div class="screen-bottom two" @click="changeTabs(1)">
              <span>2</span>
            </div>
            <div class="screen-left three" @click="changeTabs(2)">
              <span>3</span>
            </div>
            <div class="screen-top four" @click="changeTabs(3)">
              <span>4</span>
            </div>
            <div class="screen-top five" @click="changeTabs(4)">
              <span>5</span>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-top">
            <div class="layout">
              <img src="../../static/images/product/card_left.png" />
              <div class="right">
                <h2>人脸摄像头设备</h2>
                <p>抓拍来访客户头像</p>
              </div>
              <div class="btn">客户来访</div>
            </div>
            <div class="sperate"></div>
            <div class="layout">
              <img src="../../static/images/product/card_right.png" />
              <div class="right">
                <h2>认证检验设备</h2>
                <p>核验成交客户身份</p>
              </div>
              <div class="btn">客户成交</div>
            </div>
          </div>
          <div class="card-content">
            <div class="face">
              <div class="title">人脸识别算法</div>
              <div class="item">
                <img src="../../static/images/product/face1.png" />
                <div class="right">
                  <h2>人脸检测</h2>
                  <p>检测人脸位置，锁定人脸坐标</p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/face2.png" />
                <div class="right">
                  <h2>人脸跟踪</h2>
                  <p>精准定位人脸，持续跟踪面部</p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/face3.png" />
                <div class="right">
                  <h2>人脸对比</h2>
                  <p>对比相似度，返回置信度可调节阈值</p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/face4.png" />
                <div class="right">
                  <h2>人脸属性</h2>
                  <p>检测人脸性别、年龄等属性特征</p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/face5.png" />
                <div class="right">
                  <h2>人脸查找</h2>
                  <p>基于人脸图像或视频、与注册库比对查找</p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/face6.png" />
                <div class="right">
                  <h2>活体检测</h2>
                  <p>支持RGB/IR活体检测，预防恶意攻击</p>
                </div>
              </div>
            </div>
            <div class="check">
              <div class="title">认证检验算法</div>
              <div class="item">
                <img src="../../static/images/product/check1.png" />
                <div class="right">
                  <h2>身份证信息读取</h2>
                  <p>
                    身份证读卡器可快速、精确地读取身份证芯片里的真实姓名/身份证号/身份证头像等信息
                  </p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/check2.png" />
                <div class="right">
                  <h2>真人检测</h2>
                  <p>
                    根据客户对机器随机提出动作指令的响应情况，检测是否真人操作
                  </p>
                </div>
              </div>
              <div class="item">
                <img src="../../static/images/product/check3.png" />
                <div class="right">
                  <h2>人脸检测与比对</h2>
                  <p>
                    现场抓取人脸图像、检测、提取人脸生物特征与读取的身份证头像进行比对
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="process">
      <div class="second-title">
        <div class="frist-line">应用场景及业务流程</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="../../static/images/product/process1.png" />
          <div class="right">
            <h2>渠道报备</h2>
            <p>
              宣传获客，提升到访转化；裂变拓客，打造经纪人圈层;快速报备，减少操作失误；高效发佣；提高带客积极性。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process2.png" />
          <div class="right">
            <h2>精准判客</h2>
            <p>
              客户到达案场，人脸识别系统自动识别客户的伴随人员，从而判断客户属性，快速识别客户有内场销售提供精准一对一服务。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process3.png" />
          <div class="right">
            <h2>来访登记</h2>
            <p>
              客户到达案场，由判客岗/内场销售接待并进行内场登记，安排跟进销售。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process4.png" />
          <div class="right">
            <h2>渠道带看确认</h2>
            <p>若有中介带看，可在平板端完成渠道带看确认。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process5.png" />
          <div class="right">
            <h2>无感抓拍</h2>
            <p>
              在大堂入门处/沙盘/区位图/样板间等处，摄像头自动无感抓拍客户人脸头像，储存至到访客户索引库。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process6.png" />
          <div class="right">
            <h2>提交验证</h2>
            <p>
              客户签约时，需提供身份证供扫描存档（抓取真实姓名/身份证号/身份证头像等信息）录入客户成交信息库。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process7.png" />
          <div class="right">
            <h2>渠道风险把控</h2>
            <p>
              监管人员根据风控报警，或巡查分析成交客户与来访客户人脸识别结果，结合业务流水综合判断，得出是否飞单/洗客/截客等结论。
            </p>
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/product/process8.png" />
          <div class="right">
            <h2>案场客流统计</h2>
            <p>
              精确统计所有进场客户，对其进行各维度统计分析，提供精准的运营数据作决策分析。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="ditch">
      <div class="big-title">
        <p>渠道管理</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>移动销售：智慧移动、高效跟客，随时随地掌控案场</h2>
        </div>
      </div>
      <div class="content">
        <div class="manage">
          <div class="left-top layout">
            <div class="btn">
              <img src="../../static/images/product/fangzi.png" />
              <span>真房源</span>
            </div>
            <div class="half">
              <p>价格销控管理</p>
              <h2>推盘节奏</h2>
            </div>
          </div>
          <div class="right-top layout">
            <div class="half">
              <p>客户意向等级</p>
              <h2>客户肖像</h2>
            </div>
            <div class="btn">
              <img src="../../static/images/product/goufangren.png" />
              <span>真房源</span>
            </div>
          </div>
          <div class="left-bottom layout">
            <div class="btn">
              <img src="../../static/images/product/guwen.png" />
              <span>置业顾问</span>
            </div>
            <div class="half">
              <h2>奖励考核</h2>
              <p>业绩排名、团队激励</p>
            </div>
          </div>
          <div class="right-bottom layout">
            <div class="half">
              <h2>销售决策</h2>
              <p class="one-line">销售金额（面积）、销售回款</p>
            </div>
            <div class="btn">
              <img src="../../static/images/product/lingdao.png" />
              <span>公司领导</span>
            </div>
          </div>
          <div class="middle-box">
            <img src="../../static/images/product/rentou.png" />
            <p>销售经理</p>
          </div>
        </div>
        <div class="cube">
          <p>① 60秒轻松录完一个客户</p>
          <p>② 成交、回款轻松看：案场实时洞察，让售楼管理更高效</p>
          <p>
            ③多个角色全面掌控案场：驻场人员、判客人员、内场销售、场外销售、营销总等
          </p>
          <p>④ 一个数据库，信息同步不滞后</p>
        </div>
      </div>
    </div>
    <address class="five-footer">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a @click="jumpService">立即咨询</a>
    </address>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      tabId: 0,
      selectId: 0,
      rowSwiper: "",
      columnSwiper: "",
      featureList: [
        {
          id: 0,
          img: require("../../static/images/product/mean_one.png"),
          title: "智能化数据采集",
          desc: "以线下人脸数据为基础，对客流统计、属性统计、轨迹统计进行采集",
        },
        {
          id: 1,
          img: require("../../static/images/product/mean_two.png"),
          title: "多维数据整合",
          desc: "以购房客户为核心，打通融合各类系统数据",
        },
        {
          id: 2,
          img: require("../../static/images/product/mean_three.png"),
          title: "AI智能分析",
          desc: "用户画像（客户标签化、画像模型）",
        },
        {
          id: 3,
          img: require("../../static/images/product/mean_four.png"),
          title: "案场核心价值",
          desc: "推进由业务处理型向营销服务型转变，提升营销，营销氛围营造",
        },
        {
          id: 4,
          img: require("../../static/images/product/mean_five.png"),
          title: "人脸识别技术",
          desc: "增强用户体验度：人脸识别、无感判断",
        },
      ],
    };
  },
  mounted() {
    let that = this;
    that.rowSwiper = new Swiper(".myRow", {
      slidesPerView: 2.5,
      freeMode: false,
      loop: false,
    });
    that.columnSwiper = new Swiper(".myColumn", {
      direction: "vertical",
      slidesPerView: "auto",
      on: {
        slideChange() {
          that.selectId = this.activeIndex;
          that.rowSwiper.slideTo(this.activeIndex, 300, false);
        },
      },
    });
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
    changeTabs(id) {
      this.tabId = id;
    },
    changeRowTabs(id, index) {
      this.selectId = id;
      this.columnSwiper.slideTo(index, 300, false);
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.css';

.five-footer {
  width: 100%;
  height: 160px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 20px;
    font-size: 24px;
    line-height: 50px;
    color: #FFFDF9;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 200px;
    height: 44px;
    margin: 16px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 44px;
    border: 1px solid #FFFEFC;
    border-radius: 5px;
    cursor: pointer;
    box-sizing: border-box;
  }
}

.effect {
  display: flex;
  justify-content: center;
  height: 668px;
  background: url('../../static/images/product/effect_bg.png') no-repeat;

  .phone-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('../../static/images/product/phone_box.png') no-repeat;
    width: 286px;
    height: 641px;
  }

  .row-tab {
    margin: -60px 20px 0 28px;
    width: 239px;
    cursor: pointer;

    .swiper-slide {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      text-align: center;
    }

    .swiper-slide.active {
      position: relative;
      color: #333333;
    }

    .swiper-slide.active::after {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      width: 21px;
      height: 1px;
      background: #333333;
    }
  }

  .column-tab {
    margin-top: 50px;
    margin-left: 64px;
    width: 229px;
    max-height: 438px;
    border-radius: 0px 0px 20px 20px;

    .swiper-container {
      width: 229px;
      max-height: 388px;
    }

    .swiper-slide {
      margin-bottom: 98px;
      width: 220px;

      span {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        padding-left: 10px;
      }

      .desc {
        width: 167px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 32px;
        margin-top: 24px;
      }
    }
  }
}

.channel {
  width: 100%;
  padding: 139px 0 0;
  background-color: #fff;

  .big-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 76px;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .small-title {
    .frist-line {
      display: flex;
      align-items: center;
    }

    h2 {
      font-weight: bold;
      margin: 0 0 0 12px;
      font-size: 22px;
      font-weight: bold;
      color: #333333;
    }

    p {
      font-size: 18px;
      font-weight: 500;
      color: #666666;
      padding: 17px 0 0 40px;
    }
  }

  .phone-title {
    font-size: 22px;
    font-weight: 800;
    color: #333333;
    margin: 80px 0 54px;
  }

  .second-title {
    .frist-line {
      font-size: 22px;
      font-weight: 800;
      color: #333333;
      margin-top: 73px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      margin-top: 16px;
      line-height: 28px;
    }
  }

  .ditch {
    padding: 144px 360px 143px;

    .content {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 95px;

      .manage {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 557px;
        height: 367px;
        background: url('../../static/images/product/manage_bg.png');
        background-repeat: no-repeat;

        .layout {
          display: flex;
        }

        .middle-box {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          p {
            margin-top: 9px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
          }
        }

        .left-top {
          position: absolute;
          left: -160px;
          top: 25px;

          .half {
            margin-left: 5px;
          }

          p {
            margin-top: -40px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }

          h2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 40px;
            padding-top: 14px;
          }
        }

        .right-top {
          position: absolute;
          left: 450px;
          top: 25px;

          .half {
            width: 120px;
          }

          p {
            margin-top: -40px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }

          h2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            padding-top: 14px;
          }
        }

        .left-bottom {
          position: absolute;
          left: -160px;
          top: 280px;

          .half {
            margin-left: 5px;
          }

          p {
            margin-top: 60px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            margin-left:-60px;
          }

          h2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin: 0px 0 10px 40px;
          }
        }

        .right-bottom {
          position: absolute;
          left: 350px;
          top: 280px;

          .half {
            width: 220px;
          }

          p {
            margin-top: 60px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 20px;
            color: #999999;
            margin-left:100px;
                 min-width:220px;
          }

          h2 {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 100px;
       
          }
          
        }

        .btn {
          min-width: 153px;
          height: 64px;
          background: #FFFFFF;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          text-align: center;
          line-height: 64px;

          span {
            padding-left: 10px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
          }
        }
      }

      .cube {
        display: flex;
        width: 100%;
        height: 120px;
        background: url('../../static/images/product/dis_cube.png');
        background-repeat: no-repeat;
        margin-top: 50px;

        p {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC;
          min-width: 300px;
          font-weight: 500;
          color: #333333;
          margin-top: 60px;
          line-height: 20px;
          padding: 0 20px;
          box-sizing: border-box;
        }
      }
    }
  }

  .discern {
    padding: 0px 360px;

    .meaning {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .item {
        display: flex;
        width: 415px;
        max-width: 50%;
        box-sizing: border-box;
        margin-top: 50px;
        transition: all 0.4s;

        img {
          max-width: 34px;
          max-height: 34px;
          width: 34px;
          height: 34px;
        }
      }

      .item:hover .right .item-title {
        color: #EDB50B;
      }

      .item-desc::after {
        position: absolute;
        content: '';
        top: 29px;
        left: 0px;
        width: 100%;
        height: 1px;
        background: #EDB50B;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 2s;
      }

      .item:hover .item-desc::after {
        transform: scaleX(1);
        transform-origin: left;
      }

      .right {
        margin-left: 28px;

        .item-title {
          font-size: 18px;
          font-weight: 800;
          color: #333333;
          margin-bottom: 24px;
        }

        .item-desc {
          position: relative;
          font-size: 16px;
          font-weight: 500;
          color: #666666;
          line-height: 28px;
        }
      }
    }

    .deploy {
       display: flex;
       justify-content:center;
      margin-top: 52px;

      .tab-nav {
        display: flex;

        .item {
          width: 174px;
          height: 70px;
          background: #FFFFFF;
          border: 1px solid #E8E8E8;
          text-align: center;
          line-height: 70px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
        }

        .active {
          border-top: 2px solid #EDB50B;
        }

        .item:hover {
          border-top: 2px solid #EDB50B;
          transform: scale(1.02);
          box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
        }
      }
    }
  }

  .process {
    padding: 0 360px;

    .frist-line {
      margin-top: 0;
    }

    .content {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: wrap;
      margin-top: 37px;
      width:1300px;

      .item:nth-child(odd) {
        border-right: 1px solid #ededef;
      }

      .item:nth-child(7), .item:nth-child(8) {
        border-bottom: 0;
      }

      .item {
        box-sizing: border-box;
        width: 600px;
        
        height: 121px;
        background: #FFFFFF;
        border-bottom: 1px solid #ededef;
        display: flex;
        padding: 17px 30px 0 30px;

        .right {
          margin-left: 23px;
        }

        h2 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }

        p {
          font-size: 16px;
          font-weight: 500;
          color: #575D6C;
          line-height: 20px;
          margin-top: 16px;
        }

        img {
          min-width:42px;
          min-height:42px;
          max-width: 42px;
          max-height: 42px;
        }
      }

      .item:hover {
        transform: scale(1.02);
        width: 599px;
        height: 121px;
        background: #FFFFFF;
        box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
        border: 0;
      }
    }
  }

  .tab-content {
    margin-top: 48px;

    .show-img {
      position: relative;
      height: 758px;
      width: 100%;
      background: url('../../static/images/product/pad.png');

      .left-top {
        background: url('../../static/images/product/left_top.png') no-repeat;
        position: absolute;
        left: 370px;
      }

      .left-bottom {
        background: url('../../static/images/product/left_bottom.png') no-repeat;
        position: absolute;
        top: 220px;
        left: 370px;
      }

      .right-top-img {
        background: url('../../static/images/product/right_top.png') no-repeat;
        position: absolute;
        width: 100%;
        left: 1000px;

        img {
          margin-left: 405px;
        }

        p {
          margin-left: 405px;
        }
      }

      .right-middle {
        background: url('../../static/images/product/right_middle.png') no-repeat;
        position: absolute;
        width: 100%;
        left: 960px;

        img {
          margin-left: 430px;
        }

        p {
          margin-left: 430px;
        }
      }

      .right-bottom {
        background: url('../../static/images/product/right_bottom.png') no-repeat;
        position: absolute;
        left: 1270px;
        top: 250px;

        img {
          margin-left: 125px;
        }

        p {
          margin-left: 125px;
        }
      }

      .houese {
        box-sizing: border-box;
        min-width: 400px;
        min-height: 264px;
        padding: 5px;
        z-index: 2;

        p {
          width: 250px;
          text-align: center;
          font-size: 18px;
          margin-top: 7px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }

      .pad-content {
        position: absolute;
        top: 40px;
        left: 700px;

        .screen-left {
          position: absolute;
          background: url('../../static/images/product/screen_left.png');
          background-repeat: no-repeat;
          min-width: 45px;
          min-height: 31px;
          line-height: 61px;
          z-index:3;

          span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #181818;
            padding-left: 5px;
          }
        }

        .screen-top {
          position: absolute;
          background: url('../../static/images/product/screen_top.png');
          background-repeat: no-repeat;
          width: 61px;
          height: 43px;
          line-height: 61px;
          text-align: center;

          span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #181818;
          }
        }

        .screen-bottom {
          position: absolute;
          background: url('../../static/images/product/screen_bottom.png');
          background-repeat: no-repeat;
          width: 61px;
          height: 43px;
          line-height: 20px;
          text-align: center;

          span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #181818;
          }
        }

        .one {
          top: 193px;
          left: 10px;
        }

        .two {
          top: 220px;
          left: 230px;
        }

        .three {
          top: 100px;
          left: 282px;
        }

        .four {
          top: 310px;
          left: 530px;
        }

        .five {
          top: 310px;
          left: 230px;
        }
      }
    }
  }

  .card {
    position: relative;
    background: url('../../static/images/product/s_card.png');
    width: 1180px;
    height: 752px;
    margin: 0 auto;
    top: -130px;

    .card-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 65px 74px 0 74px;

      .sperate {
        width: 1px;
        height: 52px;
        background: #E7E7E7;
      }

      .layout {
        display: flex;
        align-items: center;

        .right {
          margin-left: 24px;
        }

        h2 {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
        }

        p {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-top: 16px;
        }

        .btn {
          width: 92px;
          height: 30px;
          background: #EDB50B;
          margin-left: 95px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          text-align: center;
          line-height: 30px;
        }
      }
    }

    .card-content {
      display: flex;
      justify-content: space-between;
      padding: 40px 74px 0 74px;

      .face {
        width: 100%;
      }

      .title {
        font-size: 19px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        padding-left: 11px;
        border-left: 3px solid #EDB50B;
      }

      .item {
        display: flex;
        align-items: flex-start;
        margin: 25px 0 0 12px;
        line-height: 22px;
      }

      .right {
        margin-left: 14px;
        margin-top:-8px;

        h2 {
        vertical-align:text-top;
        padding:0;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
          margin-bottom: 6px;
        }

        p {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/MarketChannel.vue